module.exports = __webpack_public_path__ + "img/kk-bottom.6b73cb57.png";